import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Phone } from "lucide-react";
import { SITE } from "../data/site";

export const StickyCTA = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 420);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <AnimatePresence>
            {visible && (
                <motion.div
                    key="sticky-cta"
                    data-testid="sticky-mobile-cta"
                    initial={{ y: 90, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 90, opacity: 0 }}
                    transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                    className="fixed inset-x-0 bottom-0 z-50 md:hidden bg-cream/90 backdrop-blur-xl border-t border-teal/10 px-4 pt-3 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
                >
                    <div className="flex items-center gap-3">
                        <a
                            href={SITE.phoneHref}
                            data-testid="sticky-call-button"
                            className="flex flex-1 items-center justify-center gap-2 rounded-full bg-coral py-4 text-base font-semibold text-cream shadow-lg shadow-coral/25 active:bg-coral-dark"
                        >
                            <Phone className="h-5 w-5" />
                            Sună acum
                        </a>
                        <a
                            href="#preturi"
                            data-testid="sticky-pricing-button"
                            className="flex items-center justify-center rounded-full px-5 py-4 text-sm font-semibold text-teal ring-1 ring-teal/25 active:bg-teal/5"
                        >
                            Prețuri
                        </a>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
